import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React, { useState, useEffect, useRef } from 'react';
import { Alert, Button, Container, Row, Col } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import styles from '../styles/file-uploader.less';
import { LinearProgressWithLabel } from './LinearProgressWithLabel';
import { STATUS_COMPRESSING, STATUS_UPLOADING, STATUS_DONE, STATUS_ERROR, compressFile } from './compressFile';
import { prettyBytes } from '../utils/prettyBytes';
import { baseFormats, compressFormats } from './formats';
import { GraphistryWebFileUploader } from './GraphistryWebFileUploader';
var UPLOAD_BASE_PATH = '';
//const UPLOAD_BASE_PATH = 'http://localhost';

import logger from '../utils/logger';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var log = logger.createLogger('Dropper');
function patchFileStatus(setFiles, fileIdx, msg) {
  log.debug({
    nfo: msg,
    fileIdx: fileIdx
  }, '@patchFileStatus');
  return setFiles(function (filesLatest) {
    log.debug({
      fileIdx: fileIdx,
      nfo: msg
    }, 'setFiles');
    var out = filesLatest.slice();
    out[fileIdx] = _objectSpread(_objectSpread({}, filesLatest[fileIdx]), msg);
    return out;
  });
}
function ReloginAlert(_ref) {
  var code = _ref.code;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var msg = /*#__PURE__*/_jsxs("span", {
    children: ["Error ", code, ": Try ", /*#__PURE__*/_jsx("a", {
      href: "/accounts/logout/",
      children: "logging out"
    }), " and back in, or check file format & logs"]
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Alert, {
      show: show,
      variant: "danger",
      children: [/*#__PURE__*/_jsx(Alert.Heading, {
        children: "Service error"
      }), /*#__PURE__*/_jsx("p", {
        children: msg
      }), /*#__PURE__*/_jsx("hr", {}), /*#__PURE__*/_jsxs("div", {
        className: "d-flex justify-content-end",
        children: [/*#__PURE__*/_jsx("a", {
          href: "/accounts/logout/",
          children: /*#__PURE__*/_jsx(Button, {
            variant: "outline-danger",
            children: "Log out and back in"
          })
        }), "\xA0", /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return setShow(false);
          },
          variant: "outline-secondary",
          children: "Dismiss"
        })]
      })]
    }), !show && /*#__PURE__*/_jsx("span", {
      children: msg
    })]
  });
}
function formatDropperError() {
  var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  log.error({
    theMsg: err
  }, 'formatDropperError');
  if (!err) {
    return '';
  }
  if (err.replace(/\n/g, '') == 'Error: Failed file transfer: Failure during metadata analysis: Failed looking up file') {
    return /*#__PURE__*/_jsx(ReloginAlert, {
      code: '1'
    });
  }
  if (err.replace(/\n/g, '') == 'Error: Failed file transfer: Error: Request failed with status code 502') {
    return /*#__PURE__*/_jsx(ReloginAlert, {
      code: '2'
    });
  }
  return "Unexpected error: ".concat(err);
}
function isBigExcel(file) {
  var n = (file.name || '').toLowerCase();
  if (!file.size || file.size <= 10 * 1024 * 1024) {
    return false;
  }
  for (var _i = 0, _arr = ['.xlsx', '.xls']; _i < _arr.length; _i++) {
    var p = _arr[_i];
    if (n.endsWith(p) || n.endsWith("".concat(p, ".zip"))) {
      return true;
    }
  }
  return false;
}

//user :: {csrfToken: str, csrfmiddlewaretoken: str}
//compressionSuffix :: '' | '.gz' | ...
function uploadFile(patchThisFileStatus, user, file, data, compressedBytes) {
  var compressionSuffix = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  log.debug({
    user: user,
    file: file,
    data: data,
    compressedBytes: compressedBytes,
    compressionSuffix: compressionSuffix
  }, '@uploadFile');
  var uploader = new GraphistryWebFileUploader({}, {
    csrfToken: user.csrfToken,
    csrfmiddlewaretoken: user.csrfmiddlewaretoken,
    activeOrganization: user.activeOrganization,
    username: user.username
  }, 'csrf', null, UPLOAD_BASE_PATH);
  return uploader.createFile({
    name: "".concat(file.name).concat(compressionSuffix),
    erase: false
  }).then(function (_ref2) {
    var file_id = _ref2.file_id;
    patchThisFileStatus({
      reason: "created file ".concat(file_id, ", now uploading"),
      file_id: file_id
    });
    return uploader.uploadFileData(data, {
      erase: false,
      progress: function progress(_progress) {
        var loaded = _progress.loaded,
          total = _progress.total;
        patchThisFileStatus({
          reason: 'upload progress',
          compressFinishedMS: Date.now(),
          uploadedBytes: loaded,
          sizeCompressedBytes: compressedBytes,
          status: STATUS_UPLOADING
        });
      }
    }).then(function (fileStats) {
      patchThisFileStatus({
        reason: 'finished uploading',
        uploadFinishedMS: Date.now(),
        uploadedBytes: compressedBytes,
        sizeCompressedBytes: compressedBytes,
        fileStats: fileStats,
        status: STATUS_DONE
      });
    });
  }).catch(function (exn) {
    log.error({
      exn: exn
    }, "Uploader failed");
    //Handle fail in UI
    patchThisFileStatus({
      reason: 'failed file create/upload',
      compressFinishedMS: Date.now(),
      status: STATUS_ERROR,
      error: (exn || 'Failed creating file').toString()
    });
  });
}
function onDrop(setFiles, user, setAcceptedFiles, fileCountRef, acceptedFiles) {
  var _this = this;
  setAcceptedFiles(function () {
    return acceptedFiles;
  });
  log.debug({
    acceptedFiles: acceptedFiles,
    user: user
  }, 'onDropt new files');

  // Reserve contiguous indices for this drop synchronously from the ref, so rapid
  // successive drops (before a re-render) do not collide on the same slots. The ref
  // tracks the latest committed file count.
  var baseOffset = fileCountRef.current;
  fileCountRef.current += acceptedFiles.length;

  //TODO skip compression of already-compressed data..
  //TODO uploading...
  var newEntries = acceptedFiles.map(function (file) {
    return {
      size: file.size,
      name: file.name,
      status: STATUS_COMPRESSING,
      compressStartedMS: Date.now(),
      compressedBytes: 0,
      sizeCompressedBytes: 0,
      uploadedBytes: 0
    };
  });

  // Pure state update: only append the placeholder rows here. Network side
  // effects must NOT run inside the updater. React StrictMode double invokes
  // updaters in dev, which would fire every create or upload twice.
  setFiles(function (prevFiles) {
    return prevFiles.concat(newEntries);
  });

  // Kick off compression/upload once, outside the updater.
  acceptedFiles.forEach(function (file, i) {
    var patchThisFileStatus = patchFileStatus.bind(_this, setFiles, baseOffset + i);
    var compression = null;
    try {
      compression = new GraphistryWebFileUploader().resolveFileCompression({
        name: file.name
      });
    } catch (e) {}
    if (compression) {
      patchThisFileStatus({
        name: file.name,
        size: file.size,
        reason: 'Start uploading',
        compressFinishedMS: Date.now(),
        compressedBytes: file.size,
        uploadStartedMS: Date.now(),
        uploadedBytes: 0,
        sizeCompressedBytes: file.size,
        status: STATUS_UPLOADING
      });
      uploadFile(patchThisFileStatus, user, file, file, file.size, '');
    } else {
      compressFile(setFiles, baseOffset, file, i, function (err, out) {
        if (err) {
          patchThisFileStatus({
            reason: 'compress progress',
            compressFinishedMS: Date.now(),
            status: STATUS_ERROR,
            error: err
          });
        } else {
          var bytes = out.bytes,
            data = out.data;
          patchThisFileStatus({
            reason: 'finished compress',
            compressFinishedMS: Date.now(),
            uploadStartedMS: Date.now(),
            uploadedBytes: 0,
            sizeCompressedBytes: data.byteLength,
            status: STATUS_UPLOADING
          });
          uploadFile(patchThisFileStatus, user, file, data, data.byteLength, '.gz');
        }
      });
    }
  });
}

// Build accept object for react-dropzone v14+
// Format: { 'mime/type': ['.ext1', '.ext2'], ... }
var acceptedFormats = function () {
  // Build all accepted extensions
  var allExtensions = baseFormats.slice(); //[.csv, ... ]
  compressFormats.forEach(function (sfx) {
    //.tar.gz, ...
    allExtensions = allExtensions.concat(baseFormats.map(function (format) {
      return "".concat(format).concat(sfx);
    }));
  });

  // Map to MIME types for react-dropzone v14+ format
  // Use a catch-all approach with empty string key to accept by extension
  return {
    'text/csv': allExtensions.filter(function (e) {
      return e.includes('.csv');
    }),
    'application/json': allExtensions.filter(function (e) {
      return e.includes('.json');
    }),
    'application/vnd.ms-excel': allExtensions.filter(function (e) {
      return e.includes('.xls');
    }),
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': allExtensions.filter(function (e) {
      return e.includes('.xlsx');
    }),
    'application/x-parquet': allExtensions.filter(function (e) {
      return e.includes('.parquet');
    }),
    'application/x-avro': allExtensions.filter(function (e) {
      return e.includes('.avro');
    }),
    'application/x-orc': allExtensions.filter(function (e) {
      return e.includes('.orc');
    }),
    'application/x-arrow': allExtensions.filter(function (e) {
      return e.includes('.arrow');
    }),
    'application/gzip': allExtensions.filter(function (e) {
      return e.endsWith('.gz');
    }),
    'application/zip': allExtensions.filter(function (e) {
      return e.endsWith('.zip');
    }),
    'application/x-tar': allExtensions.filter(function (e) {
      return e.includes('.tar');
    }),
    'application/x-xz': allExtensions.filter(function (e) {
      return e.endsWith('.xz');
    }),
    'application/x-bzip2': allExtensions.filter(function (e) {
      return e.endsWith('.bz2');
    })
  };
}();
export function Dropper(_ref3) {
  var visible = _ref3.visible,
    user = _ref3.user,
    files = _ref3.files,
    setFiles = _ref3.setFiles;
  log.debug({
    files: files,
    visible: visible,
    user: user,
    acceptedFormats: acceptedFormats
  }, 'Dropper::render files');
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    acceptedFiles = _useState4[0],
    setAcceptedFiles = _useState4[1];

  // Track the committed file count so consecutive drops compute correct indices
  // even before a re-render, without reading stale closure state. files only grows
  // on drop (status patches mutate in place), so this stays in sync.
  var fileCountRef = useRef(files.length);
  useEffect(function () {
    fileCountRef.current = files.length;
  }, [files.length]);
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("h5", {
      className: styles['dropper-instr-header'],
      children: "Add files"
    }), /*#__PURE__*/_jsx(Dropzone, {
      onDrop: onDrop.bind(this, setFiles, user, setAcceptedFiles, fileCountRef),
      accept: acceptedFormats,
      children: function children(_ref4) {
        var getRootProps = _ref4.getRootProps,
          getInputProps = _ref4.getInputProps;
        log.debug({
          acceptedFiles: acceptedFiles,
          files: files
        }, 'Dropzone renderer');
        return /*#__PURE__*/_jsxs("div", {
          className: "container",
          children: [/*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, getRootProps({
            className: styles['dropzone']
          })), {}, {
            children: [/*#__PURE__*/_jsx("input", _objectSpread({}, getInputProps())), /*#__PURE__*/_jsx("h4", {
              children: "Drop files, or click box to select and upload"
            }), /*#__PURE__*/_jsxs("h5", {
              children: ["Filename must include data and compression format: ", baseFormats.join(', '), " (and .zip, .gz)"]
            }), /*#__PURE__*/_jsx("h5", {
              children: "For CSV, export as UTF-8."
            }), /*#__PURE__*/_jsx("i", {
              className: "fa fa-plus ".concat(styles['dropper-area-icon'])
            }), /*#__PURE__*/_jsx("h5", {
              children: "Files should contain either nodes, edges, or rows of arbitrary data."
            }), /*#__PURE__*/_jsx("h5", {
              children: "Currently, at most one file of each type can be active at a time."
            })]
          })), files && files.length ? /*#__PURE__*/_jsxs("aside", {
            children: [/*#__PURE__*/_jsx("div", {
              children: "\xA0"
            }), /*#__PURE__*/_jsx("h4", {
              children: "Uploads"
            }), /*#__PURE__*/_jsx(Container, {
              className: styles['uploads'],
              children: files.map(function (file, i) {
                return /*#__PURE__*/_jsxs(Row, {
                  children: [/*#__PURE__*/_jsx(Col, {
                    className: "text-right",
                    sm: 2,
                    children: file.status === STATUS_DONE ? file.fileStats && file.fileStats.is_valid ? /*#__PURE__*/_jsx("i", {
                      className: "fa fa-check text-success"
                    }) : /*#__PURE__*/_jsx("i", {
                      className: "fa fa-warning text-warning"
                    }) : file.status === STATUS_UPLOADING ? /*#__PURE__*/_jsx("span", {
                      className: "text-primary",
                      children: "uploading ".concat(prettyBytes(file.uploadedBytes), " of ").concat(prettyBytes(file.sizeCompressedBytes))
                    }) : file.status === STATUS_COMPRESSING ? /*#__PURE__*/_jsx("span", {
                      className: "text-primary",
                      children: "compressing ".concat(prettyBytes(file.compressedBytes), " of ").concat(prettyBytes(file.size))
                    }) : file.status === STATUS_ERROR ? /*#__PURE__*/_jsx("i", {
                      className: "fa fa-times text-danger"
                    }) : null
                  }), /*#__PURE__*/_jsx(Col, {
                    sm: 4,
                    children: /*#__PURE__*/_jsx("b", {
                      children: file.name
                    })
                  }), /*#__PURE__*/_jsx(Col, {
                    sm: 6,
                    children: file.status === STATUS_ERROR ? /*#__PURE__*/_jsx("span", {
                      className: 'text-danger',
                      children: formatDropperError((file.error || 'Error').toString())
                    }) : file.status === STATUS_DONE ? file.fileStats && file.fileStats.is_valid ? /*#__PURE__*/_jsx("span", {
                      className: "text-success",
                      children: "".concat(prettyBytes(file.size), " (").concat(prettyBytes(file.sizeCompressedBytes), " compressed)")
                    }) : /*#__PURE__*/_jsx("span", {
                      children: "".concat(prettyBytes(file.size), " (").concat(prettyBytes(file.sizeCompressedBytes), " compressed) - Uploaded with errors: Proceed to Clean step to fix parsing errors")
                    }) : file.status === STATUS_COMPRESSING ? /*#__PURE__*/_jsx(LinearProgressWithLabel, {
                      value: file.size ? Math.floor(100 * file.compressedBytes / file.size) : 0,
                      color: "secondary"
                    }) : file.status === STATUS_UPLOADING ? /*#__PURE__*/_jsxs("div", {
                      children: [/*#__PURE__*/_jsx(LinearProgressWithLabel, {
                        value: file.sizeCompressedBytes ? Math.floor(100 * file.uploadedBytes / file.sizeCompressedBytes) : 0
                      }), isBigExcel(file) ? ' Large Excel uploads take longer to process, please wait...' : '']
                    }) : null
                  })]
                }, "file_".concat(i));
              })
            })]
          }) : null]
        });
      }
    })]
  });
}